<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            <h4>Text*: </h4>
            <input class="toolTipText" type="text" v-model="TooltipText" @change="saveToolTip('text')" :disabled="!$parent.mediaProperty.isActive" />
            <TranslatedText v-if="$parent.mediaProperty.configuration.textJson && $parent.mediaProperty.configuration.textJson.length > 1"
                                :textJson="$parent.mediaProperty.configuration.textJson"
                                position="bottom" alignment="start" :defaultLanguage="$parent.mediaProperty.defaultLanguage"></TranslatedText>
        </div>
        <div class="formRow">
            <h4>Position</h4>
            <select v-model="$parent.mediaProperty.configuration.position" @change="saveToolTip" :disabled="!$parent.mediaProperty.isActive">
                <option v-for="record in positions" :key="record.value" :value="record.displayName">{{record.internalName}}</option>
            </select>
        </div>
        <div class="formRow">
            <h4>Alignment</h4>
            <select v-model="$parent.mediaProperty.configuration.alignment" @change="saveToolTip" :disabled="!$parent.mediaProperty.isActive">
                <option v-for="record in alignments" :key="record.value" :value="record.displayName">{{record.internalName}}</option>
            </select>
        </div>
        <div class="formRow">
            <h4>Use Smart Repositioning?</h4>
            <input type="checkbox" v-model="$parent.mediaProperty.configuration.useSmartRepositioning" @change="saveToolTip" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
    </div>
    
</template>

<script>
import {data} from '../../shared/data';
import {translation} from '../../shared/translation';
import TranslatedText from '@/components/shared/TranslatedText.vue';

export default {
    name: 'ToolTipEdit',
    components: { TranslatedText },
    data: function() {
        return {
            positions: [],
            alignments: []    
        }
    },
    async mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                text: '', 
                position: 'right',
                alignment: 'middle',
                useSmartRepositioning: true
            }
        }

        this.positions = await data.getEnumList("ToolTipPositions");
        this.alignments = await data.getEnumList("ToolTipAlignments");
    },
    computed: {
        TooltipText: {
            get() {
                return translation.getTextForLanguage(this.$parent?.mediaProperty?.configuration?.textJson, this.$parent.mediaProperty.defaultLanguage);

            },
            set(newText) {
                translation.setTextForLanguage(this.$parent.mediaProperty.configuration, this.$parent.mediaProperty.defaultLanguage, 'textJson', newText);
            }
        },
    },
    methods: {
        saveToolTip: async function(fieldName) {
            if(this.TooltipText) {
                if(fieldName === 'text') {
                    this.$parent.mediaProperty.configuration[fieldName + 'Json'] =
                        await translation.addTranslations(this.$parent.mediaProperty.configuration[fieldName + 'Json'], 
                                    this.TooltipText, this.$parent.mediaProperty.languages, this.$parent.mediaProperty.defaultLanguage);
                }   

                const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
                if(!this.$parent.mediaProperty.id && resp.id) {
                    this.$parent.mediaProperty.id = resp.id;
                    this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
                }
            } else {
                this.$toast.error('Text must not be empty');
            }
        },
        addLanguage: async function(lang) {
            await translation.addTranslationToField(this.$parent.mediaProperty.configuration.textJson, lang, this.$parent.mediaProperty.defaultLanguage, true);
            await this.saveToolTip();
        },
        deleteLanguage: async function(lang) {
            translation.removeLanguageFromField(this.$parent.mediaProperty.configuration.textJson, lang);
            await this.saveToolTip();
        }
    }
}

</script>
<style scoped>

</style>